<template>
  <div class="content">
    <el-row type="flex">
      <el-col :span="12">
        <el-form
          label-position="top"
          :rules="rules"
          ref="form"
          label-width="80px"
          :model="form"
        >
          <el-form-item label="中文折扣码标题" prop="lang_list[1].title">
            <el-input
              v-model="form.lang_list[1].title"
              placeholder="请输入折扣码标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="英文折扣码标题" prop="lang_list[0].title">
            <el-input
              v-model="form.lang_list[0].title"
              placeholder="请输入折扣码标题"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="繁体折扣码标题" prop="lang_list[2].title">
            <el-input
              v-model="form.lang_list[2].title"
              placeholder="请输入折扣码标题"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="兑换所需积分" prop="exchange_value">
            <el-input-number
              :controls="false"
              :min="0"
              :precision="0"
              :step="1"
              v-model="form.exchange_value"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="使用时间" prop="date">
            <el-row type="flex">
              <el-date-picker
                style="width: 100%"
                v-model="form.date"
                @change="changedata"
                type="datetimerange"
                range-separator="至"
                format="yyyy 年 MM 月 dd 日 hh:mm:ss"
                value-format="yyyy-MM-dd hh:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-row>
          </el-form-item>
          <el-form-item label="门槛" prop="min_price">
            <el-radio-group v-model="form.min_price_type">
              <el-radio :label="0">无门槛</el-radio>
              <el-radio :label="1">有门槛</el-radio>
            </el-radio-group>
            <div v-if="form.min_price_type == 1" style="margin-top: 10px">
              <el-input
                type="number"
                v-model="form.min_price"
                :min="0"
                :controls="false"
                placeholder="请输入门槛金额"
                style="width: 100%"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="商品（如需指定商品请填写）"
            prop="entitled_product_ids"
          >
            <el-select
              style="width: 100%"
              v-model="form.entitled_product_ids"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入商品ID或关键词"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in entitled_product_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="折扣类型" prop="value_type">
            <el-select v-model="form.value_type" placeholder="请选择类型">
              <el-option label="固定金额" value="fixed_amount"></el-option>
              <el-option label="百分比" value="percentage"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="折扣"
            prop="value"
            v-if="form.value_type == 'percentage'"
          >
            <el-input-number
              placeholder="请输入"
              :max="100"
              :min="0"
              :controls="false"
              type="number"
              v-model="form.value"
            >
            </el-input-number>
            %
          </el-form-item>
          <el-form-item label="折扣" prop="value" v-else>
            <el-input-number
              placeholder="请输入"
              :controls="false"
              type="number"
              v-model="form.value"
            >
            </el-input-number>
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button @click="back"> 返回 </el-button>
              <el-button type="primary" @click="store" :loading="btnLoading"
                >提交</el-button
              >
            </el-row>
          </el-form-item>
        </el-form></el-col
      >
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      options: [
        {
          value: '选项1',
          label: '非会员',
        },
        {
          value: '选项2',
          label: '网红',
        },
        {
          value: '选项3',
          label: '套餐A',
        },
        {
          value: '选项4',
          label: '套餐B',
        },
      ],
      loading: false, // 新增loading状态
      btnLoading: false,
      rules: {
        'lang_list[0].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'lang_list[1].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'lang_list[2].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        value: [
          {
            required: true,
            message: '请输入折扣',
            trigger: 'change',
          },
        ],
        value_type: [
          {
            required: true,
            message: '请选择折扣类型',
            trigger: 'change',
          },
        ],
        min_price: [
          {
            required: true,
            message: '请选择门槛',
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (
                this.form.min_price_type == 1 &&
                (!value || Number(value) <= 0)
              ) {
                callback(new Error('门槛金额需大于0'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        date: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        exchange_value: [
          {
            required: true,
            message: '请输入兑换所需积分',
            trigger: 'change',
          },
        ],
      },
      form: {
        id: '',
        date: [],
        lang_list: [
          {
            lang: 'en_US',
            title: '',
          },
          {
            lang: 'zh-CN',
            title: '',
          },
          // {
          //   lang: 'zh-TW',
          //   title: '',
          // },
        ],
        start_at: '',
        min_price: '',
        end_at: '',
        value_type: '',
        value: '',
        exchange_value: '',
        min_price_type: 0,
        entitled_product_ids: [], // 初始化为数组
      },
      timeout: null,
      entitled_product_options: [], // 商品选项列表
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.detail()
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        request({
          url: '/api/backend/product/list',
          method: 'get',
          params: {
            keywords: query,
            limit: 10,
            page: 1,
          },
        })
          .then((res) => {
            this.loading = false
            if (res.code == 0) {
              this.entitled_product_options = res.data.data.map((item) => {
                return {
                  value: item.id,
                  label: item.title,
                }
              })
            }
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        this.entitled_product_options = []
      }
    },
    back() {
      this.$router.back()
    },
    detail() {
      request({
        url: '/api/backend/coupon/detail',
        method: 'get',
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          if (Number(res.data.min_price) == 0) {
            res.data.min_price = 0
            res.data.min_price_type = 0
          } else {
            res.data.min_price = Number(res.data.min_price)
            res.data.min_price_type = 1
          }
          // 不要整体替换form，保持响应式
          Object.assign(this.form, res.data)
          this.form.date = [res.data.start_at, res.data.end_at]
          // 赋值商品ID
          this.form.entitled_product_ids = res.data.entitled_product_ids || []
          // 直接赋值后端返回的商品选项
          this.entitled_product_options =
            res.data.entitled_product_options || []
        }
      })
    },
    store() {
      if (this.form.min_price_type == 0) {
        this.form.min_price = 0
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/coupon/store',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.$router.push({
                path: '/operation/RPlist',
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        // 保证form.date和选择器同步
        this.form.date = [val[0], val[1]]
        this.form.start_at = val[0]
        this.form.end_at = val[1]
      } else {
        this.form.date = []
        this.form.start_at = ''
        this.form.end_at = ''
      }
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
